import React from 'react'

interface IProps {
    className?: string
    children?: any
    onClick?: () => void
}

const TableItem: React.FC<IProps> = ({className, children, onClick}) => {
    return (
        <div
            onClick={onClick}
            className={`flex-1 grid px-[20px] py-[20px] gap-[12px] overflow-x-clip items-center border-b hover:bg-bg_green cursor-pointer sm:px-[5px] ${className}`}>
            {children}
        </div>
    )
}

export default TableItem
